export const caseStudies = [{
        title: 'Assam Cancer Care Foundation (ACCF)',
        content: "The Government of Assam and the Tata Trusts set forth on their joint initiative of establishing a comprehensive cancer care network in the State. And that needed to be amplified in an exhibition that was a starting point for the Prime Minister's visit to the inauguration event.",
        logo: '../assets/ACCF.png',
        logoH: '70px',
        logoW: '130px',
        link: "/assam-cancer-care-foundation"
    },
    {
        title: 'Department Of Agriculture',
        content: "DOA works hard toward highlighting and raising awareness about the various equipment, techniques & schemes made available by the Directorate, for the farmers of Assam through an LED van roadshow.",
        logo: '../assets/DOA.png',
        logoH: '70px',
        logoW: '200px',
        link: "/dept-of-agri"
    },
    {
        title: 'Jal Jeevan Mission Meghalaya',
        content: "JJM prioritises the provision of FHTCs in quality-affected areas, villages in drought-prone and desert areas & Sansad Adarsh Gram Yojana (SAGY) villages along with functionality of these taps.",
        logo: '../assets/JJM1.png',
        logoH: '70px',
        logoW: '70px',
        link: "/jjm"
    },
    {
        title: 'APART',
        content: "APART, a project undertaken by the Govt. of India and World Bank to support and facilitate agri-business investments, increasing agriculture productivity and market access, along with enabling smallholder farmers to produce crops that are resilient to recurrent floods or droughts in the State.",
        logo: '../assets/APART Logo2.png',
        logoH: '70px',
        logoW: '70px',
        link: "/apart"
    },
    {
        title: 'Bajaj Auto',
        content: "Our objective for the client was to drive sales, improve the conversion rate & increase the digital presence of 104 dealers across Northeast India.",
        logo: '../assets/bajaj.png',
        logoH: '70px',
        logoW: '60px',
        link: "/bajaj-auto"
    },
    {
        title: 'CCI Competition Commission Of India',
        content: "Management of Social Media & Digital presence of the Competition Commission Of India, specifically targeting platforms such as Instagram, Facebook, YouTube, Twitter & LinkedIn.",
        logo: '../assets/CCI.png',
        logoH: '80px',
        logoW: '80px',
        link: "/cci"
    },
    {
        title: 'Pernod Ricard',
        content: "The goal for this project was highlight and create buzz about the Limited Edition Imperial Blue Pack designed by Shantanu and Nikhil.",
        logo: '../assets/Pernod_Ricard.png',
        logoH: '70px',
        logoW: '180px',
        link: "/pernod-ricard"
    },
    {
        title: 'National Health Mission (NHM)',
        content: "The objective of this project was to make sure everyone in Assam is aware of the 7th International Day of Yoga and actively participates in the contest.",
        logo: '../assets/NHM.png',
        logoH: '70px',
        logoW: '90px',
        link: "/nhm"
    },
    {
        title: 'UNICEF',
        content: "Monitored and tracked Adolescent and Child Rights Issues with a focus on UNICEF priority areas in English as well as vernaculer, for print, electronic, online, and social media in Assam, Meghalaya, Arunachal Pradesh, Manipur, Mizoram, Nagaland, Sikkim and Tripura.",
        logo: '../assets/UNICEF-logo.png',
        logoH: '70px',
        logoW: '130px',
        link: "/unicef"
    },
    {
        title: 'Brahmaputra Board',
        content: "Brahmaputra Aamantran Abhiyan, a month long rafting expedition on the river Brahmaputra was documented on ground and on social media, right from its inception in Arunachal Pradesh to its closing in Goalpara.",
        logo: '../assets/BrahmaputraBoard.png',
        logoH: '70px',
        logoW: '70px',
        link: "/brahmaputra-board"
    }
]